import { Component } from '@angular/core';
import { DashboardService, IKalenderData } from '../dashboard.service';
import { AppService } from '../../shared/app.service';
import { of, merge, Observable } from 'rxjs';
import { jumpToAnchor } from '../../shared/helpers';
import { createCmdFactory } from '@cevi/rxjscommands';
import { switchMap, map } from 'rxjs/operators';
import { ZittingListComponent } from '../../shared/zitting-list/zitting-list.component';
import { NgIf, AsyncPipe } from '@angular/common';

interface IKalenderVm {
  zittingen: IKalenderData[];
}

const emptyVm = {
  zittingen: [],
};


@Component({
    selector: 'app-kalender',
    templateUrl: './kalender.component.html',
    styleUrls: ['./kalender.component.scss'],
    standalone: true,
    imports: [NgIf, ZittingListComponent, AsyncPipe],
    providers:[DashboardService]
})
export class KalenderComponent /*implements OnInit, AfterViewInit, OnDestroy*/ {

  public vm$: Observable<IKalenderVm>;
  public vm: IKalenderVm;

  constructor(
    private appService: AppService,
    private dashboardService: DashboardService) {

    this.appService.routing.createCurrentHistoryItem('Dashboard');
    const cmdFactory = createCmdFactory<IKalenderVm>();
    cmdFactory.addMapAction(this.retrieveDataAction$, 'retrieveData');
    this.vm$ = cmdFactory.merge(emptyVm);
  }

  private initialRefresh$ = of(true);
  private retrieveDataAction$ = merge(this.initialRefresh$, this.appService.refresh$).pipe(
    switchMap(_ => this.dashboardService.getKalender(0)),
    map(zittingen => (vm: IKalenderVm) => {
      let lastMonth = 0;
      let lastYear = 0;
      let zittingFragment;
      const currentMonth = new Date().getMonth();
      const currentYear = new Date().getFullYear();
      zittingen.forEach(z => {
        z.DatumZitting = new Date(z.DatumZitting as string);
        z.identifier = `z_${z.Id}`;
        if (z.DatumZitting.getFullYear() === lastYear && z.DatumZitting.getMonth() === lastMonth) {
          z.IsMonthChanged = false;
          return;
        }
        z.IsMonthChanged = true;
        lastMonth = z.DatumZitting.getMonth();
        lastYear = z.DatumZitting.getFullYear();
        if (!zittingFragment && currentMonth === lastMonth && currentYear === lastYear) {
          zittingFragment = `z_${z.Id}`;
        }
      });
      jumpToAnchor(zittingFragment);
      return { ...vm, zittingen };
    })
  );

  getZittingId(zitting: IKalenderData) {
    return zitting.Id;
  }

  navigateToArchief() {
    this.appService.routing.navigateTo(['/zittingarchief']);
  }

}
